

$(function() {

	var timer = null;

	let statusCodes = new Map();
	statusCodes.set(200, 'OK');
	statusCodes.set(400, 'Bad Request');
	statusCodes.set(404, 'Not Found');
	statusCodes.set(500, 'Internal Server Error');


	function getStatusText(code) {
		
		if (statusCodes.has(code)) {
			return statusCodes.get(code)
		} else {
			return 'unknown'
		}
	}


	function updateText(id, textContent) {

		let element = document.getElementById(id);
		element.textContent = textContent;
	}


	function updateResponseStatus(textContent) {
		updateText("api_response_status", textContent);
	}


	function updateResponseBody(textContent) {
		updateText("api_response_body", textContent);
	}


	function updateResponseTime(time_in_mills) {

		if(!time_in_mills) {
			updateText("api_response_time", '');
			return;
		}

		let rating = responseTimeRating(time_in_mills);		
		let html = `${time_in_mills} ms <i class=\"bi bi-speedometer2\ ${rating}" style=\"font-size: 20px;\"></i>`

		let element = document.getElementById("api_response_time");
		element.innerHTML = html;
	}	


	function responseTimeRating(time_in_mills) {

		if (time_in_mills < 100) {
			return "text-success";
		} else if (time_in_mills < 500) {
			return "text-warning"
		} else {
			return "text-danger"
		}
	}


	function handleResponse(request) {

		updateResponseTime(Date.now() - timer);
		updateResponseStatus(`${request.status} [${getStatusText(request.status)}]`)
		
       	let json = JSON.parse(request.responseText);
       	let formatted = JSON.stringify(json, undefined, 2);
		
		updateResponseBody(formatted);
	}


	function postJSON(payload) {

		$.ajax({
			contentType: 'application/json',
			data: payload,
			success: function(data, textStatus, request) {
				handleResponse(request);
			},
			error: function(request, textStatus, errorThrown) {
				handleResponse(request);
			},
			processData: false,
			type: event.target.method,
			url: event.target.action
		});
	}


	function postFormData(form_data) {

		$.ajax({
			data: form_data,
			success: function(data, textStatus, request) {
				handleResponse(request);
			},
			error: function(request, textStatus, errorThrown) {
				handleResponse(request);
			},
			type: event.target.method,
			url: event.target.action
		});
	}


	function resetResults() {

		updateResponseTime('');
		updateResponseStatus('');
		updateResponseBody();
	}


	function showSpinner() {

		let div = $("<div class=\"d-flex justify-content-center\"><div class=\"spinner-grow text-warning\" role=\"status\"></div></div>");
		$("#api_response_status").append(div);
	}


	$('#api_call').submit(function( event ) {

		timer = Date.now();

		resetResults();
		showSpinner();

		if(event.target.json) {
			postJSON(event.target.json.value);
		} else {
			postFormData($(this).serialize());
		}

		// prevent rails from submitting the form
		return false;
	});
});

